import { UIHeading2, Spinner, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SubAgentSearch.css';
import agentsImg from './assets/agents.png';
import searchImg from './assets/search@2x.png';

type TSubAgentSearchProps = {
  inputNode: React.ReactNode;
  subAgentsNode: React.ReactNode | null;
  errorNode: React.ReactNode | null;
  isLoading: boolean;
  isEmptySearch: boolean;
  isEmptyList: boolean;
  isTopTabsRedesigned: boolean;
};

export const SubAgentSearch: React.FC<TSubAgentSearchProps> = ({
  inputNode,
  subAgentsNode,
  errorNode,
  isLoading,
  isEmptySearch,
  isEmptyList,
  isTopTabsRedesigned,
}) => {
  return (
    <div className={isTopTabsRedesigned ? styles['container-redesigned'] : styles['container']}>
      {inputNode}
      {subAgentsNode}
      {isLoading && (
        <div className={styles['spinner']}>
          <Spinner size={16} />
        </div>
      )}
      {errorNode && <div className={styles['error']}>{errorNode}</div>}
      {isEmptySearch && (
        <div className={styles['empty']} data-name="SubAgentsSearchList_empty">
          <div className={styles['image']}>
            <img src={searchImg} width={200} height={200} alt="Иконка поиска" />
          </div>
          <div className={styles['heading']}>
            <UIHeading2 color="text-primary-default">Не смогли найти сотрудника</UIHeading2>
            <UIText1 color="text-secondary-default">
              Возможно, вы опечатались: <br />
              попробуйте ещё раз
            </UIText1>
          </div>
        </div>
      )}
      {isEmptyList && (
        <div className={styles['empty']} data-name="SubAgentsList_empty">
          <div className={styles['image']}>
            <img src={agentsImg} width={130} height={100} alt="Иконка сотрудников" />
          </div>
          <div className={styles['heading']}>
            <UIHeading2 color="text-primary-default">Здесь будут чаты ваших сотрудников</UIHeading2>
            <UIText1 color="text-secondary-default">
              Вы пока не добавили ни одного <br />
              сотрудника
            </UIText1>
          </div>
        </div>
      )}
    </div>
  );
};
